import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AppIcon } from '../icons';
import styled from '@emotion/styled';
export const Watermark = () => {
    return _jsx(AppIcon, { name: "StreemGlyphWhiteIcon" });
};
export const CompanyWatermark = styled.img(({ hide = false, height = '56px', width = '56px' }) => {
    return {
        height: height,
        width: width,
        objectFit: 'contain',
        '@media (max-height: 600px)': {
            // hide the company logo on smaller phones but only for the call lobby
            display: hide ? 'none' : 'block',
        },
    };
});
export const StreemWatermark = styled(Watermark)({
    height: '56px',
    width: '56px',
    objectFit: 'contain',
    position: 'fixed',
    top: '300px',
    left: '75px',
});
//# sourceMappingURL=watermark.js.map